import { Chip } from '@/components/ui'
import type { VendorPORow } from '../api/types'
import { daysPastDue, isOverduePO } from '../utils/overdue'

export function POStatusCell({ row }: { row: VendorPORow }) {
  if (isOverduePO(row)) {
    const days = daysPastDue(row.expected_receipt)
    return (
      <Chip size="xs" variant="danger" dot>
        {days !== null ? `${days}d late` : 'LATE'}
      </Chip>
    )
  }
  if (row.qty_open > 0 && row.qty_received > 0) {
    return (
      <Chip size="xs" variant="warning" dot>
        PARTIAL
      </Chip>
    )
  }
  if (row.qty_open > 0) {
    return (
      <Chip size="xs" variant="info" dot>
        OPEN
      </Chip>
    )
  }
  return (
    <Chip size="xs" variant="success" dot>
      RECEIVED
    </Chip>
  )
}
